module.exports = {
    get: function() {
        let seed = 0;

        if (window.performance && window.performance.now) {
            seed = Math.random(window.performance.now());
        } else {
            seed = Math.random(new Date().getMilliseconds());
        }

        return Math.floor(Math.random(seed) * (1000000 - 0) + 0);
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/almost-random.js